export default __webpack_public_path__ + "static/media/Comic-Sans-MS.ea5f1c51.otf";